module.exports = __webpack_public_path__ + "static/media/map_course_line_icon_mini.457642a0.svg";